module.exports = __webpack_public_path__ + "media/components/shared/images/plans-abd31e89fdeb7ef3d1b654cae4bf5ba4.png";